<template>
  <form @submit.prevent="onsubmit">
    <va-input
      v-model="email"
      type="text"
      :label="$t('auth.login_username')"
      :error="!!emailErrors.length"
      :error-messages="emailErrors"
    />

    <va-input
      v-model="password"
      type="password"
      :label="$t('auth.password')"
      :error="!!passwordErrors.length"
      :error-messages="passwordErrors"
    />

    <div class="auth-layout__options d-flex align--center justify--space-between">
      <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')" />
      <router-link class="ml-1 link" :to="{ name: 'recover-password' }">
        {{
        $t("auth.recover_password")
        }}
      </router-link>
    </div>

    <div class="d-flex justify--center mt-3">
      <va-button type="submit" class="my-0">{{ $t("auth.login") }}</va-button>
    </div>
  </form>
</template>

<script>
import axios from "axios";
axios.defaults.withCredentials = true;
export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: []
    };
  },
  computed: {
    formReady() {
      return !this.emailErrors.length && !this.passwordErrors.length;
    }
  },
  methods: {
    onsubmit() {
      this.emailErrors = this.email ? [] : ["Email is required"];
      this.passwordErrors = this.password ? [] : ["Password is required"];
      if (!this.formReady) {
        return;
      }
      let email = this.email;
      let password = this.password;
      let keepLoggedIn = this.keepLoggedIn;
      this.$store
        .dispatch("login", { email, password, keepLoggedIn })
        .then(() => this.$router.push("/"))
        .catch(err => console.log(err));

      let data = {
        email: this.email,
        password: this.password
      };

      axios
        .post("/api/login", data)
        .then(response => {
          console.log("Logged in");
          this.$router.push({ name: "dashboard" });
        })
        .catch(errors => {
          console.log("Cannot log in");
        });
    }
  }
};
</script>

<style lang="scss"></style>
